// extracted by mini-css-extract-plugin
export default {"progress_bar":"ProgressBar_progress_bar__X1vzh","crown":"ProgressBar_crown__qQT3-","progress_bar_percentage":"ProgressBar_progress_bar_percentage__0XhEz"};